/*
 * Jira Ticket:
 * Created Date: Mon, 6th Apr 2020, 17:06:40 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const createSiteMutation = gql`
  mutation createSite(
    $projectId: ID!
    $name: String!
    $postCode: String!
    $location: LatLngInput!
  ) {
    data: createSite(
      projectId: $projectId
      name: $name
      location: $location
      postCode: $postCode
    ) {
      id
      name
      postCode
      project {
        id
        name
        organisation {
          id
        }
      }
      location {
        lat
        lng
      }
      statistics {
        numberOfTowers
        numberOfBuilders
        numberOfApprovers
      }
    }
  }
`;
